import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import logo from '../images/dashboard/logo.png'
import axios from 'axios'

function UpdateProducts() {

    const navigate = useNavigate();

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const [allProducts, setAllProducts] = useState([])

    const [searchItem, setSearchItem] = useState('')

    const fetchProduct = async () => {
        try {
            const response = await fetch(`${apiBaseUrl}/getAllProductsForNoSize/BLACKBATON_2526`);
            const data = await response.json();
            if (data.length > 0) {

                const filtered = data.filter(item =>
                    item.itemname?.toLowerCase().includes(searchItem.toLowerCase())
                );
                setAllProducts(filtered);
            }
        } catch (error) {
            console.error('Error fetching product:', error);
        }
    };

    useEffect(() => {
        fetchProduct()
    }, [searchItem])

    const homePage = () => {
        navigate('/');
    }

    const dashboard = () => {
        navigate('/Dashboard');
    }


    const imageuploadpage = () => {
        navigate('/imageupload');
    }

    const offerUpdatepage = () => {
        navigate('/offerupdate');
    }

    const categoryaddpage = () => {
        navigate('/subcategoryadd');
    }

    const handleAllColorsUpdate = () => {
        navigate('/updateColors');
    }

    const handleAllProductsUpdate = () => {
        navigate('/updateProducts');
    }

    const handleSearch = (e) => {
        setSearchItem(e.target.value)
    }
    const handleWhatsappConfig = () => {
        navigate('/WhatsappConfig');
    }



    return (
        <div className='flex flex-col w-full lg:gap-8 gap-4 mb-12 relative'>
            {/* Header Section - unchanged */}
            <div className='sticky bg-white z-10 top-0 w-full lg:px-12 px-3 lg:py-5 py-2 flex lg:justify-between justify-center items-center border-b-2 border-[#D9D9D9]'>
                <img src={logo} alt="logo" className='w-[104px] h-[44px] cursor-pointer lg:flex hidden' onClick={homePage} />

                <div className='flex flex-row lg:gap-8 gap-4'>
                    <span className='lg:text-base text-sm font-[600] font-montserrat text-[#7D7D7D] hover:text-black cursor-pointer '
                        onClick={dashboard}>
                        Orders
                    </span>
                    <span
                        className='lg:text-base text-sm font-[600] font-montserrat cursor-pointer text-[#7D7D7D] hover:text-black transition-colors duration-200'
                        onClick={homePage}
                    >
                        Home
                    </span>

                    <span
                        className='lg:text-base text-sm font-[600] font-montserrat cursor-pointer text-[#7D7D7D] hover:text-black transition-colors duration-200'
                        onClick={imageuploadpage}
                    >
                        Image Upload
                    </span>
                    <span
                        className='lg:text-base text-sm font-[600] font-montserrat cursor-pointer text-[#7D7D7D] hover:text-black transition-colors duration-200'
                        onClick={offerUpdatepage}
                    >
                        Add Offer
                    </span>
                    <span
                        className='lg:text-base text-sm font-[600] font-montserrat cursor-pointer text-[#7D7D7D] hover:text-black transition-colors duration-200'
                        onClick={handleAllColorsUpdate}
                    >
                        All Colors
                    </span>
                    <span
                        className='lg:text-base text-sm font-[600] font-montserrat cursor-pointer text-black hover:text-black transition-colors duration-200'
                        onClick={handleAllProductsUpdate}
                    >
                        All Products
                    </span>
                    {/* <span
                        className='lg:text-base text-sm font-[600] font-montserrat cursor-pointer text-[#7D7D7D] hover:text-black transition-colors duration-200'
                        onClick={handleWhatsappConfig}
                    >
                        Whatsapp
                    </span> */}

                </div>
            </div>

            <div className='lg:px-12 px-3 w-full lg:mt-6 mt-3'>
                <div className='border-2 border-[#EFEFEF] rounded-t-[10px] w-full lg:block hidden'>
                    <div className='h-[60px] w-full flex items-center px-5 lg:text-xl text-lg font-[500] font-montserrat'>
                        <div className='w-full flex gap-4 justify-start items-center'>
                            <span className=' text-left'>All Products</span>

                        </div>
                        <div className='w-max flex gap-3'>
                            <input type="text"
                                className=' border rounded-md border-[#ccc] text-[1rem] px-2 py-1 focus:outline-none'
                                value={searchItem}
                                placeholder='Search...'
                                onChange={handleSearch} />
                            <div className='border rounded-md border-[#ccc] flex justify-center items-center py-1 px-2 font-bold cursor-pointer hover:bg-[#d9d9d9]' onClick={() => {
                                setSearchItem('')
                            }}>
                                ⟳
                            </div>
                        </div>
                    </div>

                    <div className='flex flex-row h-[60px] w-full bg-[black]'>

                        <div className='w-[10%] border-r-2 border-[#E7E7E7] flex justify-center items-center px-3 '>
                            <span className='text-lg font-[500] font-montserrat text-[white]'>SI.No</span>
                        </div>
                        <div className='w-[70%] border-r-2 border-[#E7E7E7] flex items-center px-3 '>
                            <span className='text-lg font-[500] font-montserrat text-[white]'>Item Name</span>
                        </div>
                        <div className='w-[20%] flex justify-center items-center px-3'>
                            <span className='text-lg font-[500] font-montserrat text-[white]'>has Size</span>
                        </div>
                    </div>

                    {allProducts.map((pro, index) => {
                        const isOn = pro.noSize === null;

                        const handleSize = async (slno) => {
                            try {
                                // Prepare value to send
                                const newNoSize = isOn ? 1 : null;

                                // Call backend API
                                const response = await axios.post(`${apiBaseUrl}/updateIsSize/BLACKBATON_2526`, {
                                    slno,
                                    noSize: newNoSize,
                                });

                                if (response.data.success) {
                                    // Update frontend state instantly
                                    setAllProducts(prevProducts =>
                                        prevProducts.map(item =>
                                            item.slno === slno
                                                ? { ...item, noSize: newNoSize } // update only that row
                                                : item
                                        )
                                    );
                                }

                            } catch (error) {
                                console.error("Error updating size:", error);
                            }
                        };

                        return (
                            <div
                                key={`${index}_${searchItem}`}
                                className={`order-row flex flex-row h-auto py-3 w-full border-b-2 border-[#EFEFEF] overflow-hidden z-1
                                ${index % 2 === 0 ? 'bg-gray-100' : 'bg-white'}`}
                                style={{ animationDelay: `${index * 0.01}s` }}
                            >
                                <div className='w-[10%] flex justify-center items-center px-3 border-r-2 border-[#EFEFEF]'>
                                    {index + 1}
                                </div>

                                <div className='w-[70%] flex items-center px-3 border-r-2 border-[#EFEFEF]'>
                                    {pro.itemname}
                                </div>

                                <div className='w-[20%] flex items-center justify-center px-3 flex-row gap-3 border-r-2 border-[#EFEFEF]'>
                                    <button
                                        onClick={() => handleSize(pro.slno)}
                                        className={`px-4 py-1 rounded-full font-semibold text-white transition-colors duration-300 
                                        ${isOn ? 'bg-green-500 hover:bg-green-600' : 'bg-red-500 hover:bg-red-600'}`}
                                    >
                                        {isOn ? 'On' : 'Off'}
                                    </button>
                                </div>
                            </div>
                        );
                    })}


                </div>
            </div>
        </div>
    )
}

export default UpdateProducts